import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class FileRecord extends RecordBase {
  static defaultAttributes = {
    name:                      '',
    is_active:                 true,
    pack_type:                 null,
    key:                       null,
    url:                       '',
    files:                     [],
    order:                     0,
    created_at:                '',
    updated_at:                '',
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    const trAttr = (attr) => t(`files.attributes.${attr}`);
    if(!this._attributeNames){
      this._attributeNames = {
        name:        trAttr('name'),
        is_active:   trAttr('is_active'),
        pack_type:   trAttr('pack_type'),
        key:         trAttr('key'),
        url:         trAttr('url'),
        files:       trAttr('files'),
        order:       trAttr('order'),
        created_at:  trAttr('created_at'),
        updated_at:  trAttr('updated_at'),
      };
    }
    return this._attributeNames;
  }

  toParams(attrs={}){
    const {
      name,
      is_active,
      pack_type,
      key,
      url,
      files,
      order,
      created_at,
      updated_at,
    } = this.toObject();
    return {
      data:{
        attributes:{
          name,
          is_active,
          pack_type,
          key,
          url,
          files,
          order,
          created_at,
          updated_at,
          ...attrs
        }
      }
    };
  }
}
